module.exports = __webpack_public_path__ + "static/media/money-pence-five.b63ed6a7.svg";